<template>
    <li class="user_memo" v-show="isShow">
        <div class="title_s">{{ $t('popup_user_reservation.label_medical_history') }}</div>
        <div class="btn_in_box w_full">
            <textarea :placeholder="$t('popup_user_reservation.placeholder_medical_history')" 
                :value="noteContent" 
                :disabled="isReservationOnly"
                @input="updateNoteContentValue($event.target.value)">
            </textarea>
            <button class="btn_dgray btn_xs btn" 
                :disabled="isReservationOnly || !isDiff"
                @click="action_Save">
                {{ $t('common.save') }}
            </button>
        </div>
    </li>
</template>


<script>
import { showAlertPopup } from '../../../../../sheet-alert'
import { closePopup } from '../../../../../sheet-overlays'
import { handleRefresh } from '@/v2/views/Main/V2ReservationManagement/sheet-refresh'
import { setUserNoteChangedStatus, registerGuard, unregisterGuard } from '../../popup-edit-guard'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { useV2ReservationUserNoteUpdateMutation } from '@/composables/queries/v2reservationusernote/use-v2-reservationusernote-update-mutation'

export default {
    setup() {
        const { mutateAsync: mutateUserNote } = useV2ReservationUserNoteUpdateMutation()
        return { mutateUserNote }
    },
    props: {
        isShow: Boolean,
        hservice: Object,
        reservationUserNote: Object,
        noteContent: String
    },
    data() {
        return {
            isLoading: false,

            initialNoteContent: undefined,
        }
    },
    watch: {
        noteContent: {
            immediate: true,
            handler: function (newValue) {
                if (this.initialNoteContent === undefined)  {
                    this.initialNoteContent = newValue
                    return
                }
                setUserNoteChangedStatus(this.isDiff)
            }
        },
    },
    computed: {
        isReservationOnly: function () {
            return this.hservice?.isUnregisteredUser ?? false
        },
        isDiff: function () {
            const originContent = this.reservationUserNote?.content ?? ''
            return originContent != this.noteContent
        }
    },
    mounted() {
        this.registerFunction()
    },
    destroyed() {
        this.unregisterFunction()
    },
    methods: {
        registerFunction() {
            registerGuard('AlertEditUserNote', (resolve) => {
                this.showAlert(resolve)
            })
        },
        unregisterFunction() {
            unregisterGuard('AlertEditUserNote')
        },
        // MARK: - IBActions
        action_Save: function () {
            this.updateReservationUserNote()
        },

        updateNoteContentValue(content) {
            this.$emit('input', content)
            this.$emit('editing-status-changed', true)
        },

        // MARK: - Private
        showAlert(resolve) {
            showAlertPopup('AlertEditUserInfo', this.handleAlertPopupLeft, this.handleAlertPopupRight, undefined, resolve, resolve)
        },
        handleAlertPopupLeft(resolve) {
            if (resolve == undefined) {
                closePopup()
            } else {
                resolve()
            }
        },
        async handleAlertPopupRight(resolve) {
            await this.updateReservationUserNote()
            if (resolve == undefined) {
                closePopup()
            } else {
                resolve()
            }
        },

        // MARK: - Network
        async updateReservationUserNote() {
            try {
                if (this.isLoading) { return }
                this.isLoading = true
                let hospitalID = this.hospital.selectedHospital._id
                let hserviceID = this.hservice._id
                let userID = this.hservice.userID._id
                let model = {
                    hospitalID: hospitalID,
                    hserviceID: hserviceID,
                    userID: userID,
                    content: this.noteContent
                }
                try {
                    await this.mutateUserNote(model)
                } catch (err) {
                    // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                    if (!isApiErrorWithCode(err)) throw err
                    console.log(err)
                    return
                }
                this.$emit('editing-status-changed', false)
                this.initialNoteContent = this.noteContent

                handleRefresh()
                setUserNoteChangedStatus(false)

            } finally {
                this.isLoading = false
            }
        },
    }
}
</script>